export function absoluteUrl(domain: string, path: string): string {
    if (!path || /^https?:\/\//i.test(path)) return path;
    if (path.startsWith('//')) return `https:${path}`;
    return `https://${domain}${path.startsWith('/') ? '' : '/'}${path}`;
}
